// Reduced motion toggle buttons (templates/partials/reducedmotion_toggle.html).
// The .reduce-motion class it toggles is what styles.css and the game's JS
// check (via prefersReducedMotion() in preferences.js), not the media query.

import { setupPreferenceToggle } from './preferences.js'

setupPreferenceToggle({
    cookieName: 'reducedmotion',
    className: 'reduce-motion',
    selector: '.reducedmotion-toggle',
})
